import { useAuth } from '../contexts/AuthContext';

function LoginPage() {
  const { signInWithGoogle, error } = useAuth();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg)',
      }}
    >
      <div className="card" style={{ maxWidth: 400, textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>
          CCA — Real Estate Deal Analyzer
        </h1>
        <p
          style={{
            color: 'var(--text-muted)',
            marginBottom: '1.5rem',
            fontSize: '0.875rem',
          }}
        >
          Sign in with your Google account to continue
        </p>

        {error && (
          <div className="alert alert-error" style={{ textAlign: 'left' }}>
            {error}
          </div>
        )}

        <button
          className="btn btn-primary"
          onClick={signInWithGoogle}
          style={{ width: '100%', justifyContent: 'center' }}
        >
          Sign in with Google
        </button>
      </div>

      <span
        style={{
          position: 'fixed',
          bottom: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#9ca3af',
          fontSize: '0.75rem',
        }}
      >
        v{__APP_VERSION__}
      </span>
    </div>
  );
}

export default LoginPage;
